import { getAllsCCPC } from "@/api/baseDate";
getAll();
var continent = localStorage.getItem("allContinent") || '[]';
var jsonAllCount = JSON.parse(continent);

function _flat(arr) {
  var newArr = [];
  arr.forEach(function (item, idx) {
    if (Array.isArray(item)) {
      newArr = newArr.concat(_flat(item));
    } else {
      newArr.push(item);
    }
  });
  return newArr;
}

function getAll() {
  var all = localStorage.getItem("allContinent");

  if (all == null || all == undefined) {
    getAllsCCPC().then(function (res) {
      localStorage.setItem("allContinent", JSON.stringify(res));
    });
  }
} //查询多个洲下的国家及城市


export function getUnderCountry(codeArry) {
  var country = [];

  if (codeArry == '' || codeArry == undefined || codeArry.length < 1) {
    return country;
  }

  var codeList = new Array();

  if (typeof codeArry == 'string') {
    codeList.push(codeArry);
  } else {
    codeList = codeArry;
  }

  codeList.forEach(function (item, index) {
    jsonAllCount.forEach(function (count, index) {
      if (item == count.codeCode) {
        country.push(count.children);
      }
    });
  });
  return _flat(country);
} //只获取洲下面国家

export function getChildCountry(code) {
  var country = [];

  if (code == '' || code == undefined || typeof code != 'string') {
    return country;
  }

  jsonAllCount.forEach(function (item, index) {
    if (item.codeCode == code) {
      item.children.forEach(function (tem, index) {
        var counts = {
          'id': tem.id,
          'codeCode': tem.codeCode,
          'codeCname': tem.codeCname,
          'codeEname': tem.codeEname,
          'level': '2'
        };
        country.push(counts);
      });
    }
  });
  return _flat(country);
} //根据城市代码查询上级国家代码

export function getCountryCodeByCity(code) {
  var countryCode = '';

  if (code == '' || code == undefined || typeof code != 'string') {
    return countryCode;
  }

  var countryList = getCountryList();
  countryList.forEach(function (item, index) {
    var citys = item.children;

    if (citys != null) {
      for (var i = 0; i < citys.length; i++) {
        if (citys[i].codeCode == code) {
          countryCode = item.codeCode;
          return;
        }
      }
    }

    return;
  });
  return countryCode;
} //根据城市代码获取城市名称

export function getCityCodeName(code) {
  var codeName = '';

  if (code == '' || code == undefined || typeof code != 'string') {
    return codeName;
  }

  var cityList = getCityList();
  cityList.forEach(function (item, index) {
    if (code == item.codeCode) {
      codeName = item.codeCname;
      return;
    }
  });
  return codeName;
} //获取多个国家下的城市

export function getUnderCity(cuntryCodeArry) {
  var city = [];

  if (cuntryCodeArry == '' || cuntryCodeArry == undefined || cuntryCodeArry.length < 1) {
    return city;
  }

  var codeArry = new Array();

  if (typeof cuntryCodeArry == 'string') {
    codeArry.push(cuntryCodeArry);
  } else {
    codeArry = cuntryCodeArry;
  }

  codeArry.forEach(function (item, index) {
    var countryList = getCountryList();
    countryList.forEach(function (coun, index) {
      if (item == coun.codeCode) {
        city.push(coun.children);
      }
    });
  });
  return _flat(city);
} //获取所有洲=》国家=》城市

export function getContinentList() {
  return jsonAllCount;
} //只获取洲

export function getCon() {
  var cons = [];
  jsonAllCount.forEach(function (item, index) {
    var count = {
      'id': item.id,
      'typeName': item.typeName,
      'codeType': item.codeType,
      'codeCode': item.codeCode,
      'codeCname': item.codeCname,
      'codeEname': item.codeEname,
      'upperCode': item.upperCode,
      'codeLevel': item.codeLevel,
      'validStatus': item.validStatus
    };
    cons.push(count);
  });
  cons.push({
    'id': 'zdy1234',
    'codeCode': 'zdy',
    'codeCname': '自定义',
    'codeEname': '',
    'upperCode': '',
    'codeLevel': '1',
    'validStatus': '1'
  });
  return cons;
} //获取所有国家

export function getCountryList() {
  var countryList = [];
  jsonAllCount.forEach(function (item, index) {
    if (item.children) {
      countryList.push(item.children);
    }
  });
  return _flat(countryList);
} //获取所有城市

export function getCityList() {
  var cityList = [];
  var countryList = getCountryList();
  countryList.forEach(function (item, index) {
    if (item.children) {
      cityList.push(item.children);
    }
  });
  return _flat(cityList);
}
export function getProvince() {
  var cityList = [];
  var countryList = getCountryList();
  countryList.forEach(function (item, index) {
    if (item.codeCode == 'CHN') {
      cityList.push(item.children);
    }
  });
  return _flat(cityList);
} //获取中国省下面的城市

export function getProvinceCity(cuntryCodeArry) {
  var city = [];

  if (cuntryCodeArry == '' || cuntryCodeArry == undefined || cuntryCodeArry.length < 1) {
    return city;
  }

  var codeArry = new Array();

  if (typeof cuntryCodeArry == 'string') {
    codeArry.push(cuntryCodeArry);
  } else {
    codeArry = cuntryCodeArry;
  }

  codeArry.forEach(function (item, index) {
    var countryList = getProvince();
    countryList.forEach(function (coun, index) {
      if (item == coun.codeCode) {
        city.push(coun.children);
      }
    });
  });
  return _flat(city);
} //获取中国下面所有城市

export function getCHNCity() {
  var cityd = [];
  var countryList = getProvince();
  countryList.forEach(function (coun, index) {
    if (coun.children) {
      cityd.push(coun.children);
    }
  });
  return _flat(cityd);
}